import React, { useState } from 'react';
import './FilterModal.css';

const FilterModal = ({ 
  visible, 
  onClose, 
  categories, 
  onFilterSelect,
  selectedEducationLevelId 
}) => {
  if (!visible) return null;

  const handleSelect = (id) => {
    onFilterSelect(id);
    onClose();
  };

  return (
    <div className="filter-modal-overlay" onClick={onClose}>
      <div className="filter-modal" onClick={(e) => e.stopPropagation()}>
        <div className="filter-modal-header">
          <h2>Filter by Education Level</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="filter-modal-content">
          {categories.map((category) => (
            <div key={category.id} className="filter-section">
              <h3 
                className={`filter-title ${
                  selectedEducationLevelId === category.id ? 'selected' : ''
                }`}
                onClick={() => handleSelect(category.id)}
              >
                {category.name}
              </h3>
              <ul className="filter-list">
                {category.submenu.map((sub) => (
                  <li 
                    key={sub.id} 
                    className={`filter-item ${
                      selectedEducationLevelId === sub.id ? 'selected' : ''
                    }`}
                    onClick={() => handleSelect(sub.id)}
                  >
                    {sub.name}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterModal;